import { toSnakeCase } from './string';

type DynamicObject = Record<string, unknown>;

interface CaseConfig {
	recursive?: boolean;
}

export const toSnakeCaseKeys = (object: DynamicObject, { recursive = true }: CaseConfig = {}): DynamicObject =>
	Object.fromEntries(
		Object.entries(object).map(([key, value]) => [
			toSnakeCase(key),
			recursive && typeof value === 'object' && value !== null ? toSnakeCaseKeys(value as DynamicObject, { recursive }) : value,
		])
	);

export const pluck =
	<K extends string>(key: K) =>
	<T extends Record<K, unknown>>(value: T) =>
		value[key];

export const partial =
	<K extends string>(...keys: K[]) =>
	<T extends Record<K, unknown>>(value: T) =>
		keys.reduce((acc, curr) => ({ ...acc, [curr]: value[curr] }), {} as Pick<T, K>);

export const hasPropWithValue =
	<P extends string, O>(prop: P, value: unknown) =>
	(object: O) =>
		object[prop as unknown as keyof O] === value;
